import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/core/services/sidenav.service';
import { FusionAuthService, UserInfo } from '@fusionauth/angular-sdk';
import { BehaviorSubject } from 'rxjs';
import { UserService } from 'src/app/core/services/user.service';
import { UserExtraInfo } from 'src/app/core/interfaces/user-extra-info.interface';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('slideIn', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('300ms ease-in', style({ transform: 'translateY(0%)' })),
      ]),
    ]),
    trigger('expand', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)' }),
        animate('100ms ease-in', style({ transform: 'translateY(0%)' })),
      ]),
      // transition(':leave', [animate('100ms ease-in', style({ transform: 'translateX(-100%)' }))]),
    ]),
  ],
})
export class DashboardComponent implements OnInit {
  @Input() fullWidth!: boolean;

   //@ts-ignore
   user: Subject<UserInfo> = new BehaviorSubject<UserInfo>(null);
      //@ts-ignore
   userExtra: Subject<UserExtraInfo> = new BehaviorSubject<UserExtraInfo>(null);


  constructor(
    private router: Router,
    private navService: SidenavService,
    private route: ActivatedRoute
  ) {
    this.navService.getShowNav().subscribe((value) => {
      this.fullWidth = value;
    });
  }

  ngOnInit(): void {
    
  }
}
